import type { App } from 'vue';
import { config, logger } from '@/common/services/config';

/**
 * Plugin Vue pour l'injection de la configuration d'environnement
 */
export default {
  install(app: App) {
    // Injection de la configuration globalement
    app.config.globalProperties.$config = config;
    app.config.globalProperties.$logger = logger;

    // Fournir la configuration via injection
    app.provide('appConfig', config);
    app.provide('appLogger', logger);

    // Log de l'environnement au démarrage
    logger.log(`🚀 MN Ward beta démarré en mode ${config.mode}`);
    logger.debug('Configuration:', config);

    // Validation de l'environnement en développement
    if (config.mode === 'development') {
      validateEnvironment();
    }
  },
};

/**
 * Validation de la configuration en mode développement
 */
function validateEnvironment() {
  const warnings: string[] = [];

  if (!config.msal.clientId) {
    warnings.push('MSAL Client ID manquant');
  }

  if (!config.api.baseUrl) {
    warnings.push("URL de base de l'API manquante");
  }

  if (!config.fullCalendar.licenseKey) {
    warnings.push('Clé de licence FullCalendar manquante');
  }

  if (warnings.length > 0) {
    logger.warn('⚠️ Problèmes de configuration détectés:', warnings);
  }
}
